export const baseAPIUrl = 'https://www.resluxurygroup.com/api/';